@if (isVisible) {
  <div id="playerModal" class="modal-overlay">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">
            <i class="fa fa-user-plus"></i>
            {{ isEditMode ? "Edit Player" : "Add Player to Tournament" }}
          </h2>
        </div>
        <div class="modal-body">
          @if (!isEditMode && !isExistingPlayer()) {
            <div class="alert alert-info">
              <i class="fa fa-info-circle"></i>
              <strong>Tip:</strong> Looking for an existing player?
              <button
                type="button"
                class="btn btn-sm btn-primary m-l-sm"
                (click)="openPlayerLookup()"
                >
                <i class="fa fa-search"></i> Find Existing Player
              </button>
            </div>
            } @if (isExistingPlayer() && !isEditMode) {
            <div class="alert alert-success">
              <i class="fa fa-check-circle"></i>
              <strong>Existing Player Selected:</strong> {{ playerForm.firstName }}
              {{ playerForm.lastName }}
            </div>
          }
          <form class="form-horizontal">
            <div class="row">
              <div class="col-md-6">
                <h4 class="m-t-none">Player Information</h4>
                <div class="form-group">
                  <label class="col-sm-4 control-label">Tour:</label>
                  <div class="col-sm-8">
                    <select
                      #tourDropdown
                      class="form-control"
                      [(ngModel)]="playerForm.tourId"
                      name="tourId"
                      (ngModelChange)="onTourChanged($event)"
                      >
                      <option value="">Select Tour</option>
                      @for (tour of tours(); track tour.tourId) {
                        <option [value]="tour.tourId">{{ tour.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-4 control-label">Short Name:</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="playerForm.shortName"
                      name="shortName"
                      (ngModelChange)="onFormValueChanged()"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-sm-4 control-label">First Name:</label>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="playerForm.firstName"
                        name="firstName"
                        (ngModelChange)="onFormValueChanged()"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-4 control-label">Middle Name:</label>
                      <div class="col-sm-8">
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="playerForm.middleName"
                          name="middleName"
                          (ngModelChange)="onFormValueChanged()"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-sm-4 control-label">Last Name:</label>
                        <div class="col-sm-8">
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="playerForm.lastName"
                            name="lastName"
                            (ngModelChange)="onFormValueChanged()"
                            />
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Country:</label>
                          <div class="col-sm-8">
                            <select
                              class="form-control"
                              [(ngModel)]="playerForm.countryId"
                              name="countryId"
                              (ngModelChange)="onCountryChanged($event)"
                              >
                              <option [ngValue]="0">Select Country</option>
                              @for (country of countries(); track country.countryId) {
                                <option [ngValue]="country.countryId">
                                  {{ country.name }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-4 control-label">State:</label>
                          <div class="col-sm-8">
                            <select
                              class="form-control"
                              [(ngModel)]="playerForm.stateId"
                              name="stateId"
                    [disabled]="
                      !playerForm.countryId || filteredStates().length === 0
                    "
                              (ngModelChange)="onStateChanged($event)"
                              >
                              <option [ngValue]="0">Select State</option>
                              @for (state of filteredStates(); track state.stateId) {
                                <option [ngValue]="state.stateId">{{ state.name }}</option>
                              }
                            </select>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="col-sm-4 control-label">Hometown:</label>
                          <div class="col-sm-8">
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="playerForm.hometown"
                              name="hometown"
                              (ngModelChange)="onFormValueChanged()"
                              />
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="col-sm-4 control-label">LPGA ID:</label>
                            <div class="col-sm-8">
                              <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="playerForm.lpgaId"
                                name="lpgaId"
                                (ngModelChange)="onFormValueChanged()"
                                />
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-sm-4 control-label">LPGA Account ID:</label>
                              <div class="col-sm-8">
                                <input
                                  type="text"
                                  class="form-control"
                                  [(ngModel)]="playerForm.lpgaAccountId"
                                  name="lpgaAccountId"
                                  (ngModelChange)="onFormValueChanged()"
                                  />
                                </div>
                              </div>
                              <div class="form-group">
                                <label class="col-sm-4 control-label">WWGR ID:</label>
                                <div class="col-sm-8">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="playerForm.wwgrId"
                                    name="wwgrId"
                                    (ngModelChange)="onFormValueChanged()"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <h4 class="m-t-none">Tournament-Specific Fields</h4>
                                <div class="form-group">
                                  <label class="col-sm-4 control-label">Category:</label>
                                  <div class="col-sm-8">
                                    <select
                                      class="form-control"
                                      [(ngModel)]="playerForm.categoryId"
                                      name="categoryId"
                                      (ngModelChange)="onFormValueChanged()"
                                      >
                                      <option [value]="0">Select Category</option>
                                      @for (category of categories(); track
                                        category.tournamentPlayerCategoryID) {
                                        <option [value]="category.tournamentPlayerCategoryID">
                                          {{ category.name }}
                                        </option>
                                      }
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="col-sm-4 control-label">A/B/C Type:</label>
                                  <div class="col-sm-8">
                                    <select
                                      class="form-control"
                                      [(ngModel)]="playerForm.abcType"
                                      name="abcType"
                                      (ngModelChange)="onFormValueChanged()"
                                      >
                                      <option value="">Select Type</option>
                                      <option value="A">A</option>
                                      <option value="B">B</option>
                                      <option value="C">C</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="col-sm-4 control-label">Field Rank:</label>
                                  <div class="col-sm-8">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [(ngModel)]="playerForm.fieldRank"
                                      name="fieldRank"
                                      (ngModelChange)="onFormValueChanged()"
                                      />
                                    </div>
                                  </div>
                                  <div class="form-group">
                                    <label class="col-sm-4 control-label">A Rank:</label>
                                    <div class="col-sm-8">
                                      <input
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="playerForm.aRank"
                                        name="aRank"
                                        (ngModelChange)="onFormValueChanged()"
                                        />
                                      </div>
                                    </div>
                                    <div class="form-group">
                                      <label class="col-sm-4 control-label">R1 Wave:</label>
                                      <div class="col-sm-8">
                                        <select
                                          class="form-control"
                                          [(ngModel)]="playerForm.r1Wave"
                                          name="r1Wave"
                                          (ngModelChange)="onFormValueChanged()"
                                          >
                                          <option value="">Select Wave</option>
                                          <option value="AM">AM</option>
                                          <option value="PM">PM</option>
                                        </select>
                                      </div>
                                    </div>
                                    <hr class="hr-line-dashed" />
                                    <div class="form-group">
                                      <div class="col-sm-offset-4 col-sm-8">
                                        <div class="checkbox">
                                          <label>
                                            <input
                                              type="checkbox"
                                              [(ngModel)]="playerForm.isAmateur"
                                              name="isAmateur"
                                              (ngModelChange)="onFormValueChanged()"
                                              />
                                              Is Amateur
                                            </label>
                                          </div>
                                          <div class="checkbox">
                                            <label>
                                              <input
                                                type="checkbox"
                                                [(ngModel)]="playerForm.isSponsorInvite"
                                                name="isSponsorInvite"
                                                (ngModelChange)="onFormValueChanged()"
                                                />
                                                Sponsor Invite
                                              </label>
                                            </div>
                                            <div class="checkbox">
                                              <label>
                                                <input
                                                  type="checkbox"
                                                  [(ngModel)]="playerForm.isQualifier"
                                                  name="isQualifier"
                                                  (ngModelChange)="onFormValueChanged()"
                                                  />
                                                  Qualifier
                                                </label>
                                              </div>
                                              <div class="checkbox">
                                                <label>
                                                  <input
                                                    type="checkbox"
                                                    [(ngModel)]="playerForm.isTitleist"
                                                    name="isTitleist"
                                                    (ngModelChange)="onFormValueChanged()"
                                                    />
                                                    Is Titleist
                                                  </label>
                                                </div>
                                                <div class="checkbox">
                                                  <label>
                                                    <input
                                                      type="checkbox"
                                                      [(ngModel)]="playerForm.isCmeEligible"
                                                      name="isCmeEligible"
                                                      (ngModelChange)="onFormValueChanged()"
                                                      />
                                                      Is CME Eligible
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                      <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" (click)="closeModal()">
                                          <i class="fa fa-times"></i> Cancel
                                        </button>
                                        <button
                                          type="button"
                                          class="btn btn-primary"
                                          (click)="savePlayer()"
                                          [disabled]="!canSave"
                                          >
                                          <i class="fa fa-save"></i> Save
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }

                              <!-- Player Lookup Modal -->
                              <app-player-lookup-modal
                                (playerSelected)="onExistingPlayerSelected($event)"
                              ></app-player-lookup-modal>
